// src/utils/firebase.js
//
// Firebase used to be imported at the top of App.js, so ~250 KB of messaging SDK was in
// the first load for every user — including the ones who never allow notifications.
// It is now loaded on demand and cached.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

let messagingPromise = null;

/// Resolves to the messaging instance and the module's functions, or null when this
/// browser can't do push at all.
export function loadMessaging() {
  if (!messagingPromise) {
    messagingPromise = (async () => {
      try {
        const [{ initializeApp }, msg] = await Promise.all([
          import('firebase/app'),
          import('firebase/messaging'),
        ]);
        if (!(await msg.isSupported())) return null;
        return { messaging: msg.getMessaging(initializeApp(firebaseConfig)), ...msg };
      } catch {
        return null; // blocked, unsupported, or offline — push just stays off
      }
    })();
  }
  return messagingPromise;
}
